import FooterTags from "./FooterTags";
const FooterTagsCombined = () => {

  return (
    
    <>
      <FooterTags 
        title={"COMPANY"}
        array={[
          "About Udyog",
          "Customers Speak",
          "News",
          "Career",
          "Terms and Conditions",
          "Privacy Policy",
          "Fee and Payments Policy",
          "Shipping and Delievery Policy",
          "Return ,Refund and Cancellation Policy",
          "Contact",
        ]}
      />
      <FooterTags
        title={"SHOPPING"}
        array={[
          "Browse by Manufacturers",
          "Health Articles",
          "Offers/Coupons",
          "FAQs",
        ]}
        
      />
      <FooterTags
        title={"SOCIAL"}
        array={[
          "Facebook",
          "Twitter",
          "LinkedIn",
          "Youtube",
          "Refer & Earn",
        ]}
      />

      {/* USE THIS TO LINK SOCIAL IN ALLROUTES 
      
      <Route path='/Facebook' component={() => {
    window.location.href = 'https://facebook.com/1234';
    return null;
}}/> */}

    </>
    
  );
};
export default FooterTagsCombined;